import axios from '../plugins/axios'

export default {
  search(params){
    return axios.get('/api/v1/tags/search', {
      params: { name: params.name }
    })
  }
}
